<template>
  <div v-if="value && value.length > 0" class="error">
    {{ value }}
  </div>
</template>

<script>
  export default {
    name: "InputError",
    props: {
      value: String,
    },
  };
</script>

<style scoped>
  .error {
    color: #cc0000;
    font-size: 10px;
    font-style: italic;
    margin-top: 6px;
    left: 0;
    position: absolute;
    bottom: -23px;
  }
</style>
